export function friendlyMemorySize(byteSize: number, precision: number = 1) {
    var units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    var format = function (bytes, precision) {
        if (isNaN(parseFloat(bytes)) || isNaN(bytes) || bytes < 0) {
            return '-';
        }
        if (bytes === 0) {
            return '0 B';
        }

        // validate 'precision'
        if (isNaN(precision)) {
            precision = 1;
        }

        var unitIndex = Math.floor(Math.log(bytes) / Math.log(1024)),
            value = bytes / Math.pow(1024, unitIndex);

        return value.toFixed(precision) + ' ' + units[unitIndex];
    };

    return format(byteSize, precision);
}